export const view = {
    methods:{
        showOrder: function(e){
            var id = e.target.closest('div[name=OrderContainer]').getAttribute('data-id');
            this.$router.push({ path: 'Order', query: { id: id }})
        },
        repeatOrder: function(e){
            e.preventDefault();
            e.stopPropagation();

            var _self = this;
            var id = e.target.closest('div[name=OrderContainer]').getAttribute('data-id');

            var parameters = { 
                ID: id,
                FranchiseID: localStorage.franchiseID,
                MembershipUserID: localStorage.userMembershipID,
                GUID: localStorage.cartGuid
             };
            _self.$ooApi.orders.order.repeat.v1(parameters).then(function(response){
                if(response.success){
                    _self.refreshCart();
                }
                else{
                    console.log(response.message);
                }
            })
            // check .catch
        }
    }
}